import { combineReducers } from 'redux';

// new slices
import { leaderboardReducer } from './leaderboard';
import { playerModalReducer } from './player-modal';

const rootReducer = combineReducers({
    playerModal: playerModalReducer,
    leaderboard: leaderboardReducer
});

// @ts-expect-error
if (window.PULSE.app.redux) {
    // @ts-expect-error
    window.PULSE.app.redux.reducers.playerAwards = { root: rootReducer };
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            playerAwards: {
                root: rootReducer
            }
        }
    };
}
